module.exports = __webpack_public_path__ + "static/media/2 como vender-min.4cf6c2ab.jpg";